/**
 * @param ranges - an array of {@link NumberRange} objects.
 * @returns an aggregation of all the `ranges` elements into a single {@link NumberRange}
 */
export const aggregateNumberRanges = (ranges: NumberRange[]): NumberRange => {
    const result = ranges.reduce(
        (acc: NumberRange, range: NumberRange): NumberRange => {
            acc.max += range.max;
            acc.min += range.min;

            return acc;
        },
        { max: 0, min: 0 },
    );

    return result;
};
